import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Form,
} from "react-bootstrap";
import SVG from "react-inlinesvg"; // Per icone SVG
import { useFormik } from "formik"; // Per gestione form
import * as yup from "yup"; // Validazione
import Select from "react-select"; // Select multipla
import * as apiUtenti from "../../../../api/users"; // API utenti
import * as apiTarget from "../../../../api/target"; // API target
import { useSelector, shallowEqual } from "react-redux"; // Accesso allo stato Redux
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers"; // Helper URL
import { icons } from "../../../../config/config"; // Icone
import { roles, roleOptionsForSelect, isAgente } from "../../../../config/config";
import { Checkbox } from "@material-ui/core";

// 🔹 Espressione regolare per numero di telefono
const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

// 🔹 Schema di validazione Yup
const validationSchema = yup.object({
  firstname: yup.string().required("Inserire un nome valido"),
  lastname: yup.string().required("Inserire un cognome valido"),
  email: yup
    .string()
    .email("Inserire una mail valida")
    .required(),
  idRegion: yup
    .number(),
    // .positive("Selezionare una regione"),
    // .required("Seleziona una regione"),
  phone: yup
    .string()
    .matches(phoneRegExp, "Inserire un numero di telefono valido")
    .required("Inserire un numero di telefono valido"),
  targets: yup
    .array()
    .min(0, "Selezionare almeno un target")
    //.required("Selezionare almeno un target"),
});

// 🔹 Messaggi azioni
const actionsMessages = {
  new: "Crea",
  edit: "Modifica",
  reset: "Reset",
};

// 🔹 Etichette campi form
const formFields = {
  firstname: {
    label: "Nome",
    placeholder: "Nome...",
  },
  lastname: {
    label: "Cognome",
    placeholder: "Cognome...",
  },
  email: {
    label: "Email",
    placeholder: "Email...",
  },
  email_others: {
    label: "Email Alternative",
    placeholder: "Email Alternative...",
  },
  piva: {
    label: "P.IVA",
    placeholder: "P.IVA...",
  },
  role: {
    label: "Selezionare il ruolo",
    options: roleOptionsForSelect,
  },
  acquisti: {
    label: "Abilitato alla vendita",
  },
  notifySamples: {
    label: "Richieste campionatura / materiale",
  },
  notifyServices: {
    label: "Richieste di servizi",
  },
  notifySales: {
    label: "Richieste di vendita",
  },
  notifyProducts: {
    label: "Prodotti disponibili / non disponibili",
  },
  phone: {
    label: "Telefono",
    placeholder: "Numero di telefono...",
  },
  address: {
    label: "Indirizzo",
    placeholder: "Indirizzo...",
  },
  region: {
    label: "Regione assegnata",
    placeholder: "Regione...",
  },
  targets: {
    label: "Selezionare il target",
    placeholder: "Target...",
  },
};

// 🔹 Toolbar con pulsanti
const EditNewUtenteToolbar = ({
  submitCallback,
  closeCallback,
  resetCallback,
  loading,
  existingUtente,
}) => {
  return (
    <div>
      <Button disabled={loading} onClick={submitCallback} className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {existingUtente ? actionsMessages.edit : actionsMessages.new}
      </Button>

      <Button disabled={loading} onClick={resetCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.reset)} />
        </span>
        {actionsMessages.reset}
      </Button>

      <Button onClick={closeCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.go_back)} />
        </span>
        Indietro
      </Button>
    </div>
  );
};

export const EditNewUtente = (props) => {
  const [loading, setLoading] = useState(false);
  const [regions, setRegions] = useState([]);
  const [targetOptions, setTargetOptions] = useState([]); // Opzioni per react-select
  const [selectedTargets, setSelectedTargets] = useState([]); // Target selezionati

  // 🔹 Recupera l'utente loggato dallo stato Redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  const isAdmin = role === roles.admin || role === roles.gestore || role === roles.developer;

  // 🔹 Stato iniziale dell'utente
  const initialState = {
    id: false,
    firstname: "",
    lastname: "",
    email: "",
    piva: "",
    role: -1,
    acquisti: "0",
    notifySamples: 1,
    notifyServices: 1,
    notifySales: 1,
    notifyProducts: 1,
    phone: "",
    address: "",
    idRegion: "",
    region: "",
    targets: [],
  };

  const existingUtente = props.utente !== false;
  if (existingUtente) {
    Object.assign(initialState, props.utente);
  }

  // 🔹 Stati locali per le checkbox
  const [acquistiCheckbox, setAcquistiCheckbox] = useState(!!parseInt(initialState.acquisti));
  const [notifySamplesCheckbox, setSamplesCheckbox] = useState(!!parseInt(initialState.notifySamples));
  const [notifyServicesCheckbox, setServicesCheckbox] = useState(!!parseInt(initialState.notifyServices));
  const [notifySalesCheckbox, setSalesCheckbox] = useState(!!parseInt(initialState.notifySales));
  const [notifyProductsCheckbox, setProductsCheckbox] = useState(!!parseInt(initialState.notifyProducts));

  // 🔹 Carica le regioni dal backend
  useEffect(() => {
    apiUtenti.getRegioni(props.token).then((data) => setRegions(data));
  }, []);

  // 🔹 Carica i target dal backend
  useEffect(() => {
    apiTarget.getAll(user.authToken).then((data) => {
      const options = data.map((target) => ({
        value: target.id,
        label: target.name,
      }));
      setTargetOptions(options);

      // Sincronizza i target già associati all'utente
      if (existingUtente && props.utente!=null && props.utente.targets) {
        let ids = props.utente.targets;
        if (typeof ids === "string") ids = ids.split(",").map(Number);
        if (!Array.isArray(ids)) ids = [ids];

        const selected = options.filter((opt) => ids.includes(opt.value));
        setSelectedTargets(selected);
        formik.setFieldValue("targets", selected);
      }
    });
  }, [user.authToken]);

  // 🔹 Configurazione di Formik
  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true);
      
      const regionLabel = regions.find((reg) => reg.value == values.idRegion)?.label || "";

      const result = {
        ...values,
        acquisti: acquistiCheckbox ? 1 : 0,
        notifySamples: notifySamplesCheckbox ? 1 : 0,
        notifyServices: notifyServicesCheckbox ? 1 : 0,
        notifySales: notifySalesCheckbox ? 1 : 0,
        notifyProducts: notifyProductsCheckbox ? 1 : 0,
        id: existingUtente ? values.id : "",
        region: regionLabel,
        targets: selectedTargets.map(t => t.value),
      };

      // 🔁 Invia i dati al backend
      apiUtenti.add(props.token, result)
        .then(() => {
          setLoading(false);
          props.triggerServerUpdate();
          props.hideEditPage();
        })
        .catch((e) => {
          console.error("Errore invio:", e);
          setLoading(false);
        });
    },
  });

  // 🔹 Classe dinamica per input validati
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  return (
    <Card className="card-custom gutter-b">
      <Card.Header className="border-0 py-5 row">
        <Card.Title className="float-left col-auto">
          <h3 className="font-weight-bolder text-dark">
            {existingUtente ? "Modifica utente" : "Crea utente"}
          </h3>
        </Card.Title>

        {/* 🔹 Toolbar */}
        <EditNewUtenteToolbar
          submitCallback={formik.handleSubmit}
          resetCallback={formik.handleReset}
          closeCallback={props.hideEditPage}
          loading={loading}
          existingUtente={existingUtente}
          className="float-right col-auto"
        />
      </Card.Header>

      <Card.Body className="pt-0">
        <Form className="row">

          {/* 🔹 Nome */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.firstname.label}</Form.Label>
            <Form.Control
              type="text"
              name="firstname"
              placeholder={formFields.firstname.placeholder}
              className={getInputClasses("firstname")}
              {...formik.getFieldProps("firstname")}
            />
            {formik.touched.firstname && formik.errors.firstname ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.firstname}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Cognome */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.lastname.label}</Form.Label>
            <Form.Control
              type="text"
              name="lastname"
              placeholder={formFields.lastname.placeholder}
              className={getInputClasses("lastname")}
              {...formik.getFieldProps("lastname")}
            />
            {formik.touched.lastname && formik.errors.lastname ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.lastname}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Email */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.email.label}</Form.Label>
            <Form.Control
              type="text"
              name="email"
              placeholder={formFields.email.placeholder}
              className={getInputClasses("email")}
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.email}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Email Alternative */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.email_others.label}</Form.Label>
            <Form.Control
              type="text"
              name="email_others"
              placeholder={formFields.email_others.placeholder}
              className={getInputClasses("email_others")}
              {...formik.getFieldProps("email_others")}
            />
            {formik.touched.email_others && formik.errors.email_others ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.email_others}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 P. IVA */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.piva.label}</Form.Label>
            <Form.Control
              type="text"
              name="piva"
              placeholder={formFields.piva.placeholder}
              className={getInputClasses("piva")}
              {...formik.getFieldProps("piva")}
            />
            {formik.touched.piva && formik.errors.piva ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.piva}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Ruolo */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.role.label}</Form.Label>
            <select
              name="role"
              className={`form-control ${getInputClasses("role")}`}
              {...formik.getFieldProps("role")}
              onChange={(e) => {
                formik.handleChange(e);
                if (!isAgente(e.target.value)) setAcquistiCheckbox(false);
              }}
            >
              {formFields.role.options.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
            {formik.touched.role && formik.errors.role ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.role}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Telefono */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.phone.label}</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              placeholder={formFields.phone.placeholder}
              className={getInputClasses("phone")}
              {...formik.getFieldProps("phone")}
            />
            {formik.touched.phone && formik.errors.phone ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.phone}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Indirizzo */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label>{formFields.address.label}</Form.Label>
            <Form.Control
              type="text"
              name="address"
              placeholder={formFields.address.placeholder}
              className={getInputClasses("address")}
              {...formik.getFieldProps("address")}
            />
            {formik.touched.address && formik.errors.address ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.address}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Regione */}
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12 d-none">
            <Form.Label>{formFields.region.label}</Form.Label>
            <select
              name="idRegion"
              className={`form-control ${getInputClasses("idRegion")}`}
              {...formik.getFieldProps("idRegion")}
            >
              <option value={0}>Seleziona regione</option>
              {regions.map((e, key) => (
                <option key={key} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
            {formik.touched.idRegion && formik.errors.idRegion ? (
              <div className="fv-plugins-message-container mt-2">
                <div className="fv-help-block">{formik.errors.idRegion}</div>
              </div>
            ) : null}
          </Form.Group>

          {/* 🔹 Target (solo per Admin/Developer) */}
          {isAdmin && (
            <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
              <Form.Label>{formFields.targets.label}</Form.Label>
              <Select
                isMulti
                name="targets"
                options={targetOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                value={selectedTargets}
                onChange={(e) => {
                  const newValue = e || [];
                  setSelectedTargets(newValue);
                  formik.setFieldValue("targets", newValue);
                }}
              />
              {formik.touched.targets && formik.errors.targets ? (
                <div className="fv-plugins-message-container mt-2">
                  <div className="fv-help-block">{formik.errors.targets}</div>
                </div>
              ) : null}
            </Form.Group>
          )}

          {/* 🔹 Abilitato alla vendita (checkbox) */}
          {isAdmin && (
            <Form.Group className="col-xl-6 col-lg-6 col-sm-12 d-flex align-items-center">
              <Checkbox
                name="acquisti"
                checked={acquistiCheckbox}
                onChange={(_, checked) => setAcquistiCheckbox(checked)}
              />
              <Form.Label className="mb-0">{formFields.acquisti.label}</Form.Label>
            </Form.Group>
          )}

          {/* 🔹 Ricevi notifiche via email */}
          <div className="row col-12 mb-3">
            <div className="col-12">
              <h3 className="font-weight-bolder text-dark">Ricevi notifiche via Email 📩</h3>
            </div>
            <div className="col-6">
              <h6>La notifica avrà effetto solo sugli Admin e sui Magazzinieri</h6>
            </div>
            <div className="col-6 text-center">
              <h6>La notifica di vendita avrà effetto anche sul ruolo Contabile</h6>
            </div>
          </div>

          {/* 🔹 Notifiche campioni */}
          {isAdmin && (
            <Form.Group className="col-xl-4 col-lg-4 col-sm-12 d-flex align-items-center">
              <Checkbox
                name="notifySamples"
                checked={notifySamplesCheckbox}
                onChange={(_, checked) => setSamplesCheckbox(checked)}
              />
              <Form.Label className="mb-0">{formFields.notifySamples.label}</Form.Label>
            </Form.Group>
          )}

          {/* 🔹 Notifiche servizi */}
          {isAdmin && (
            <Form.Group className="col-xl-4 col-lg-4 col-sm-12 d-flex align-items-center">
              <Checkbox
                name="notifyServices"
                checked={notifyServicesCheckbox}
                onChange={(_, checked) => setServicesCheckbox(checked)}
              />
              <Form.Label className="mb-0">{formFields.notifyServices.label}</Form.Label>
            </Form.Group>
          )}

          {/* 🔹 Notifiche vendite */}
          {isAdmin && (
            <Form.Group className="col-xl-4 col-lg-4 col-sm-12 d-flex align-items-center">
              <Checkbox
                name="notifySales"
                checked={notifySalesCheckbox}
                onChange={(_, checked) => setSalesCheckbox(checked)}
              />
              <Form.Label className="mb-0">{formFields.notifySales.label}</Form.Label>
            </Form.Group>
          )}

          {/* 🔹 Notifiche prodotti disponibili/non disponibili */}
          {isAdmin && (
            <Form.Group className="col-xl-4 col-lg-4 col-sm-12 d-flex align-items-center">
              <Checkbox
                name="notifyProducts"
                checked={notifyProductsCheckbox}
                onChange={(_, checked) => setProductsCheckbox(checked)}
              />
              <Form.Label className="mb-0">{formFields.notifyProducts.label}</Form.Label>
            </Form.Group>
          )}
        </Form>
      </Card.Body>
    </Card>
  );
};
